import { useAuth } from "@group-link-one/gl-auth";
import {
  GL_COLORS,
  GL_EQUALIZER,
  GL_USER_CHECK,
  GLHeader,
} from "@group-link-one/grouplink-components";
import { Outlet, useNavigate } from "react-router-dom";

import { useAuthServices } from "../../Services/authService/useAuthServices";
// import { useMessageCenterLayout } from "./useMessageCenterLayout";

export function MessageCenterLayout() {
  const { user } = useAuth();
  const { logOut } = useAuthServices();
  const navigate = useNavigate();
  // const { headerNavList, headerNavItemActive } = useMessageCenterLayout();

  return (
    <>
      <GLHeader
        // headerNavListItems={headerNavList}
        // headerNavItemActive={headerNavItemActive?.id}
        onLogOut={() => logOut({})}
        user={user!}
        menuOptions={[
          {
            icon: <GL_USER_CHECK size={18} fill={GL_COLORS.FONT_COLOR} />,
            text: "Profile",
            onClick: () => navigate("/settings/overview"),
          },
          {
            icon: <GL_EQUALIZER size={18} fill={GL_COLORS.FONT_COLOR} />,
            text: "Account settings",
            onClick: () => navigate("/settings/my-account"),
          },
        ]}
      />
      <Outlet />
    </>
  );
}
